import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 border fw-bold" }, "Поставщик"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 border fw-bold" }, "Общая сумма"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 border fw-bold" }, "Место")
], -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4 border d-flex align-items-center" }
const _hoisted_4 = { class: "col-4 border d-flex align-items-center justify-content-end" }
const _hoisted_5 = { class: "col-4 border" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Не выбрано", -1)
const _hoisted_9 = { class: "col-12 text-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-lg",
    title: "Выбрать победителя"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _hoisted_1,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.protocolSuppliers, (ps) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(ps.supplier.name), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.formatMoney(ps.total)), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_form_group_ui, { "invalid-feedback": "Места не указаны или дублируется" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((ps.place) = $event),
                    class: _normalizeClass(["form-select mt-2 text-end", {'is-invalid': _ctx.state.visibleErrors && _ctx.isPlacesError}])
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (place) => {
                      return _createElementVNode("option", {
                        key: place,
                        value: place
                      }, _toDisplayString(place), 9, _hoisted_7)
                    }), 64)),
                    _hoisted_8
                  ], 10, _hoisted_6), [
                    [_vModelSelect, ps.place]
                  ])
                ]),
                _: 2
              }, 1024)
            ])
          ]))
        }), 256)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Сохранить ")
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}